import { FunctionComponent } from 'react';
import { Box, Link, Typography } from '@mui/material';
import { DocsTocEntry } from './docsHeadings';

interface DocsTocProps {
  entries: DocsTocEntry[];
}

// Optional right-hand "On this page" table of contents. Anchors scroll to the
// matching heading id rendered by DocsMarkdown.
export const DocsToc: FunctionComponent<DocsTocProps> = ({ entries }) => {
  if (entries.length === 0) return null;

  return (
    <Box
      component="nav"
      aria-label="Table of contents">
      <Typography
        variant="overline"
        sx={{ color: 'text.secondary', fontWeight: 600 }}>
        On this page
      </Typography>
      <Box
        component="ul"
        sx={{ listStyle: 'none', m: 0, p: 0, mt: 1 }}>
        {entries.map((entry) => (
          <Box
            component="li"
            key={entry.id}
            sx={{ pl: entry.level === 3 ? 2 : 0, mb: 0.75 }}>
            <Link
              href={`#${entry.id}`}
              underline="hover"
              sx={{ fontSize: 13, color: 'text.secondary' }}>
              {entry.text}
            </Link>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
